/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-Rules-condition-factory.ts to modify the generation of this file.

import { RuleConditionData } from 'lib/rules/serialization';
import { AndCondition, NotCondition, OrCondition, RuleCondition } from 'lib/rules/conditions';
import { RuleContext } from 'lib/rules/rules';


import {
  AffiliateFieldCondition,
  AffiliateFieldConditionId
} from 'src/lib/rules/conditions/AffiliateFieldCondition';

import {
  AffiliateMatchCondition,
  AffiliateMatchConditionId
} from 'src/lib/rules/conditions/AffiliateMatchCondition';

import {
  AffiliateProgramOptIn,
  AffiliateProgramOptInId
} from 'src/lib/rules/conditions/AffiliateProgramOptIn';

import {
  CookieIsPresentCondition,
  CookieIsPresentConditionId
} from 'src/lib/rules/conditions/CookieIsPresentCondition';

import {
  CookieValueCondition,
  CookieValueConditionId
} from 'src/lib/rules/conditions/CookieValueCondition';

import {
  GeoLocationStateCondition,
  GeoLocationStateConditionId
} from 'src/lib/rules/conditions/GeoLocationStateCondition';

import {
  PageIsMatchCondition,
  PageIsMatchConditionId
} from 'src/lib/rules/conditions/PageIsMatchCondition';

import {
  QueryStringCondition,
  QueryStringConditionId
} from 'src/lib/rules/conditions/QueryStringCondition';

export function getRulesConditionFactory<T extends RuleContext>(condition: RuleConditionData): RuleCondition<T> | null {
  if (condition.type == 'or') {
    const leftOperand = getRulesConditionFactory(condition.left as RuleConditionData);
    const rightOperand = getRulesConditionFactory(condition.right as RuleConditionData);
    if (!leftOperand || !rightOperand) {
      return null;
    }
    return new OrCondition(leftOperand, rightOperand);
  }

  if (condition.type == 'and') {
    const leftOperand = getRulesConditionFactory(condition.left as RuleConditionData);
    const rightOperand = getRulesConditionFactory(condition.right as RuleConditionData);
    if (!leftOperand || !rightOperand) {
      return null;
    }
    return new AndCondition(leftOperand, rightOperand);
  }

  if (condition.type == 'not') {
    const operand = getRulesConditionFactory(condition.operand as RuleConditionData);
    if (!operand) {
      return null;
    }
    return new NotCondition(operand);
  }

  
  if (condition.id === AffiliateFieldConditionId) {
    const cond = new AffiliateFieldCondition(condition);
    cond.id = AffiliateFieldConditionId;
    return cond;
  }

  if (condition.id === AffiliateMatchConditionId) {
    const cond = new AffiliateMatchCondition(condition);
    cond.id = AffiliateMatchConditionId;
    return cond;
  }

  if (condition.id === AffiliateProgramOptInId) {
    const cond = new AffiliateProgramOptIn(condition);
    cond.id = AffiliateProgramOptInId;
    return cond;
  }

  if (condition.id === CookieIsPresentConditionId) {
    const cond = new CookieIsPresentCondition(condition);
    cond.id = CookieIsPresentConditionId;
    return cond;
  }

  if (condition.id === CookieValueConditionId) {
    const cond = new CookieValueCondition(condition);
    cond.id = CookieValueConditionId;
    return cond;
  }

  if (condition.id === GeoLocationStateConditionId) {
    const cond = new GeoLocationStateCondition(condition);
    cond.id = GeoLocationStateConditionId;
    return cond;
  }

  if (condition.id === PageIsMatchConditionId) {
    const cond = new PageIsMatchCondition(condition);
    cond.id = PageIsMatchConditionId;
    return cond;
  }

  if (condition.id === QueryStringConditionId) {
    const cond = new QueryStringCondition(condition);
    cond.id = QueryStringConditionId;
    return cond;
  }
  return null;
};

